module.exports = __webpack_public_path__ + "static/media/sedanLight.cc065e7d.svg";